import { z } from 'zod';

export const BucketResultSchema = z.object({
  name: z.string(),
  timestamp_epoch: z.number(),
  timestamp: z.coerce.date(),
  status: z.string(),
  biomarkers: z.any(),
  history: z.array(z.any()),
});

export type BucketResult = z.infer<typeof BucketResultSchema>;

export const V1BucketResponseSchema = z.object({
  uuid: z.string(),
  buckets: z.array(BucketResultSchema),
});

export type V1BucketResponse = z.infer<typeof V1BucketResponseSchema>;
